import AppHeader from '../AppHeader/AppHeader';
import AppFooter from '../AppFooter/AppFooter';
import AppSetting from '../AppSetting/AppSetting';
import { Outlet } from 'react-router-dom';
import AppMenu from '../AppMenu/AppMenu';

const Home = () => {
    return (
        <div className="hold-transition skin sidebar-mini layout-fixed">
            <div className="wrapper">
                <AppHeader/>
                <AppMenu />
                <Outlet />
                <AppFooter />
                <AppSetting />
            </div>
        </div>
        
    );
};

export default Home;